import { AlertTriangle, MessageSquareX, FileWarning } from "lucide-react";

const ITEMS = [
  {
    icon: FileWarning,
    title: "Falsche Tatsachenbehauptung",
    text: "Die Bewertung enthält nachweislich falsche Angaben über Ihr Unternehmen, Ihre Dienstleistung oder Ihre Produkte.",
  },
  {
    icon: MessageSquareX,
    title: "Beleidigend oder unangemessen",
    text: "Persönliche Angriffe, Diffamierung oder Aussagen, die die Grenze zur Sachlichkeit eindeutig überschreiten.",
  },
  {
    icon: AlertTriangle,
    title: "Verstoß gegen Richtlinien",
    text: "Die Bewertung verstößt erkennbar gegen die Community-Richtlinien der Plattform (z. B. Google oder Trustpilot).",
  },
];

export default function WhenToReport() {
  return (
    <section id="leistung" data-testid="when-to-report" className="relative py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2b2620]">Wann ist eine Meldung sinnvoll?</div>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#2b2620]">
            Nicht jede negative Bewertung kann entfernt werden.
          </h2>
          <p className="mt-5 text-[#6b5f52] leading-relaxed">
            Entscheidend ist immer, ob ein Verstoß gegen die Richtlinien der jeweiligen Plattform vorliegt. In diesen Fällen kann eine strukturierte Meldung sinnvoll sein. Die finale Entscheidung über eine Entfernung trifft ausschließlich die Plattform.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {ITEMS.map(({ icon: Icon, title, text }, i) => (
            <div
              key={title}
              data-testid={`report-criterion-${i + 1}`}
              className="group relative bg-[#faf6ef] border border-black/[0.08] rounded-2xl p-7 hover:border-[#b8935a]/60 hover:bg-[#ede4d3] hover:shadow-lg transition-all"
            >
              <div className="absolute top-0 right-0 text-5xl font-heading font-semibold text-[#2b2620]/[0.04] p-4 leading-none">
                0{i + 1}
              </div>
              <div className="relative w-12 h-12 rounded-xl bg-[#2b2620]/10 border border-[#2b2620]/30 flex items-center justify-center text-[#2b2620]">
                <Icon className="w-6 h-6" />
              </div>
              <h3 className="relative mt-6 font-heading text-xl font-medium text-[#2b2620]">{title}</h3>
              <p className="relative mt-3 text-sm text-[#6b5f52] leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
